import api from '..'

export async function archiveFlowEvents(
  flowExperimentId: string,
): Promise<null> {
  await api.post(`/flow_experiments/${flowExperimentId}/archive-events`)

  return null
}
